export const ITEMS_PER_PAGE = 10;
export const ITEMS_PER_PAGE_WITH_BUFFER = 20;
export const EXCLUDED_SECTOR_IDS = [
  'd023f155-2b59-46d8-8332-82d8f4ff33d5', // CMBS
  'b5c805a6-b5c5-41f0-a6a3-1657cf9e67b6', // CLOS
  '012ba6d5-f89e-4b36-a336-2d9ef9a5b257', // RMBS
];
export const CMBS_ID = 'd023f155-2b59-46d8-8332-82d8f4ff33d5';
